export const taskKeys = {
  all: ["tasks"] as const,
  logs: (taskId: string) => ["tasks", taskId, "logs"] as const,
};

export const TASK_LIST_STALE_TIME = 2_000;
